import { DaypilotCoreEvent, SupportedObjectTypes } from './daypilot-core-event'
import { LiveFlight } from "./live-flight";

export interface ILiveFlightEvent extends DaypilotCoreEvent {
  liveFlight?: LiveFlight;
}

export class LiveFlightEvent extends DaypilotCoreEvent implements ILiveFlightEvent {
  public liveFlight?: LiveFlight;
  public canAcknowledge: boolean;

  public constructor(
    id: string,
    text: string,
    start: Date,
    end: Date,
    resource: string,
    liveFlight: LiveFlight)
  {
    super(id, text, start, end, resource, SupportedObjectTypes.LiveFlightEvent);

    this.liveFlight = new LiveFlight(liveFlight);
  }

  public static createInstance(obj: any) {
    return new LiveFlightEvent(
      obj.id,
      obj.text,
      obj.start,
      obj.end,
      obj.resource,
      obj.liveFlight
    );
  }
  
}
